import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import { css } from "styled-components";

accountMessagesStyles.messagesSection = {
    css: css`
        display:none;
    `,
}
